<template>
  <div class="atm-desktop-max-width py-4 mx-auto">
    {{ editable }}
    <b-tabs fill content-class class="pb-3">
      <b-tab @click="changeViewToCalendar('timeGridDay')" active title="Day"></b-tab>
      <b-tab @click="changeViewToCalendar('timeGridWeek')" title="Week"></b-tab>
      <b-tab @click="changeViewToCalendar('dayGridMonth')" title="Month" active></b-tab>
    </b-tabs>
    <full-calendar
      ref="fullCalendar"
      :header="{
        left: 'title',
        right: 'today prev,next',
      }"
      initialView="dayGridMonth"
      :minTime="'07:00:00'"
      :selectable="true"
      :plugins="calendarPlugins"
      :weekends="calendarWeekends"
      :events="calendarEvents"
      :editable="editable"
      :droppable="editable"
      :eventLimit="3"
      :nowIndicator="editable"
      @eventRender="eventRender"
      @eventClick="eventClick"
      @dateClick="dateClick"
      @eventDrop="eventResizeOrDrop"
      @eventResize="eventResizeOrDrop"
    >
    </full-calendar>
  </div>
</template>

<script>
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import FullCalendar from '@fullcalendar/vue';
import { EVENT_TYPE } from '@/myTasks/constants';

export default {
  components: {
    FullCalendar,
  },
  props: {
    calendarEvents: {
      type: Array,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      calendarWeekends: true,
      tooltipDisabled: false,
    };
  },
  methods: {
    changeViewToCalendar(styleView = 'timeGridDay') {
      const calendarApi = this.$refs.fullCalendar.getApi(); // from the ref="..."
      calendarApi.changeView(styleView); // call a method on the Calendar object
    },
    eventRender({ event, el }) {
      if (event.extendedProps.icon) {
        let icon = document.createElement('div');
        icon.innerHTML = `<i class="material-icons icon-size">${event.extendedProps.icon}</i>`;
        el.querySelector('.fc-title').prepend(icon);
      }
    },
    eventClick({ event }) {
      if (event.extendedProps.type === EVENT_TYPE.PROJECTS) {
        this.$router.push({
          name: 'createNewProject',
          query: { project: event.id },
        });
      } else {
        this.$router.push({
          name: 'task-detail',
          params: { taskId: event.id },
        });
      }
    },
    dateClick(event) {
      let { date, dateStr } = event;
      if (dateStr.search('T') == -1) {
        dateStr += 'T00:00:00-05:00';
      }
      const numberMonth = date.getMonth() + 1;
      const month = numberMonth < 10 ? `0${numberMonth}` : numberMonth;
      const numberDay = date.getDate();
      const day = numberDay < 10 ? `0${numberDay}` : numberDay;

      const selectDate = `${date.getFullYear()}-${month}-${day}`;
      const selectHour = dateStr;

      this.$emit('dateClick', { selectDate, selectHour });
    },
    async eventResizeOrDrop({ event }) {
      this.$emit('eventEdited', { event });
    },
    reloadCalendar() {
      const calendarApi = this.$refs.fullCalendar.getApi();
      const eventSources = calendarApi.getEventSources();
      eventSources[0].remove();
      calendarApi.addEventSource(this.calendarEvents);
      calendarApi.refetchEvents();
    },
  },
  watch: {
    calendarEvents() {
      this.reloadCalendar();
    },
  },
};
</script>

<style lang="scss">
/*Navigation tabs changeView style*/
.nav-tabs .nav-link {
  border: 0;
  color: black !important;
  font-weight: 700;
}

.nav-tabs .nav-link.active {
  border-bottom: solid 3px var(--color-main) !important;
}

/*overwriting calendar styles*/
.fc-unthemed tbody {
  background: white;
}

td.fc-widget-content:hover {
  background: var(--color-main);
}

/**Buttons style**/
.fc-button-primary,
.fc-button-primary:disabled,
.fc-button-primary:focus,
.fc-button-primary:visited,
.fc-button-primary:link,
.fc-button-primary:active,
.fc-button-primary:hover,
.fc-button-primary:not(:disabled):active,
.fc-button-primary:not(:disabled).fc-button-active {
  background-color: white;
  border-color: var(--color-main);
  color: var(--color-main);
}

.fc-button-group {
  gap: 8px;
}

.fc-today-button.fc-button.fc-button-primary {
  border: none;
}

.fc-event-container a {
  border-radius: 6px !important;
  cursor: pointer !important;
  -webkit-box-shadow: -7px 8px 8px -3px rgba(46, 56, 64, 0.44);
  -moz-box-shadow: -7px 8px 8px -3px rgba(46, 56, 64, 0.44);
  box-shadow: -7px 8px 8px -3px rgba(46, 56, 64, 0.44);
}

.fc-event,
.fc-event-dot {
  color: white !important;
}

.fc-toolbar {
  .fc-right {
    display: flex;
    flex-direction: column;

    & .fc-button-primary {
      font-size: 14px;
      font-weight: 400;
    }
  }

  h2 {
    font-size: 20px;
    font-weight: 700;
  }
}

/**Height changeView**/
.fc-time-grid-container,
.fc-time-grid,
.fc-view .fc-dayGridMonth-view .fc-dayGrid-view {
  height: auto !important;
}

.fc-widget-content .fc-day-grid-container {
  height: fit-content !important;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-content,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-list-heading td {
  border: transparent;
  font-size: max(2vh, 10px);
}

.fc-ltr .fc-axis {
  text-align: left;
}

.fc-content {
  font-size: 12px !important;
  line-height: 0.8rem !important;
}

.icon-size {
  font-size: 1.5em;
}
.fc-day-grid-event {
  margin-bottom: 6px !important;
}
.fc-title {
  width: 50vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  gap: 2px;
}

.fc-content-col {
  & a {
    display: flex;
    align-items: center;
  }
}

@media (max-width: 767px) {
  .fc-time-grid-event .fc-event .fc-start .fc-end .fc-draggable .fc-resizable {
    display: flex !important;
  }

  .fc-content {
    font-size: 9px !important;
  }
  .fc-time {
    font-weight: 600 !important;
  }

  .fc-view-container {
    overflow-x: auto;
  }

  .fc-timeGridWeek-view {
    width: 200vw;
  }
}
</style>
